import { render, staticRenderFns } from "./LayoutSitePage.vue?vue&type=template&id=1289c76d"
import script from "./LayoutSitePage.vue?vue&type=script&lang=ts"
export * from "./LayoutSitePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports